export default "__VITE_ASSET__CYIaYrUY__"